import Ob1Component from "./ob1-component";
import Util from "./util";

const selector = {
  item: ".breadcrumb-item"
};

class Breadcrumb extends Ob1Component {

  constructor(container, parameters) {
    super(container, "Breadcrumb", parameters);
  }

  /**
   * Initialisation du composant fil d'Ariane
   *
   * @param {HTMLElement} container le noeud DOM sur lequel est instancié le composant
   * @param {object} parameters les paramètres de ce composant
   */
  init(container, parameters) {
    super.init(container, parameters);

    this._addEvents();
    this.resize();
  }

  /**
   * Gestion des événements sur le composant
   * @private
   */
  _addEvents () {
    this._hOnResize = () => {
      clearTimeout(this.resizetimeout);
      this.resizetimeout = setTimeout(() => {
        this.resize();
      }, 50);
    };
    window.addEventListener("resize", this._hOnResize);
  }

  /**
   * Redimensionnement du fil d'Ariane en fonction de la place disponible
   */
  resize() {
    const elements = this.container.querySelectorAll(selector.item);
    elements[ elements.length - 1 ].style.overflow = "visible";
    elements.forEach(item => {
      item.classList.remove("sr-only");
    });

    let i = 0;
    while (i < elements.length - 2 && Util.checkOverflow(this.container)) {
      elements[ i ].classList.add("sr-only");
      i++;
    }
    elements[ elements.length - 1 ].style.overflow = "hidden";
  }

  /**
   * Décharge le composant
   */
  dispose () {

    // suppression de l'event listener qui a été créé
    window.removeEventListener("resize", this._hOnResize);

    // on appelle la méthode de suppression de composant d'Ob1Component (obligatoire)
    super.dispose();
  }
}

Breadcrumb.refs = {};

// rattachement au contexte window pour pouvoir l'utiliser en dehors du JS
window.Breadcrumb = Breadcrumb;

export default Breadcrumb;
